// import http from '@/api/http.js'
export default {
	state: {
		showCotentHeader:true,
		showCotentButton:true,
		chineseEnglish:'', //判断当前中英文状态哦
		orderTreu:false, //公共判断当前中英文状态 或者 切换中英文状态的值 比如添加css 等
		indexDetails:false, //判断显示详情导航栏还是其他的导航栏
		pathIndex:'', //当前页面的path
	},
	mutations: {
		changeValue(state, played) {
			state.showCotentHeader = played.showCotentHeader;
			state.showCotentButton = played.showCotentButton;
			state.indexDetails = played.indexDetails;
		},
		
		chineseEnglish(state, played) {
			state.chineseEnglish = played;
		},
		
		orderTreu(state, played) {
			state.orderTreu = played;
		},
		
		pathIndex(state, played){
			state.pathIndex = played;
		},
		
		
	},
	getters: {
	    // doneTodos: state => {
	    //   return state.todos.filter(todo => todo.done)
	    // },
	},
	actions: {
		async getUserInfoArr({ commit },played) {
			console.log("输出数据");
		},
	}
}


// WEBPACK FOOTER //
// ./src/store/order.js